'use client';

import { useScrollRestoration } from "@/app/hooks/useScrollRestoration";

export default function ScrollRestoration() {
  useScrollRestoration();

  return null;
}